import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class TrainingApi extends EntityApi {
    protected static GET_COLLECTION = "/api/trainings";

    protected static POST_COLLECTION = "/api/trainings";

    protected static GET_ITEM = "/api/trainings/{id}";

    protected static PUT_ITEM = "/api/trainings/{id}";

    protected static PATCH_ITEM = "/api/trainings/{id}";

    protected static DELETE_ITEM = "/api/trainings/{id}";

    protected static GET_COLLECTION_FOR_SELECT = "/api/trainings/select";

    public static async getCollectionForSelect<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FOR_SELECT,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
